import {Section} from "../../@types/privacyPolicySectionResources.tsx";
import {Language} from "../../@types/generics.tsx";

export const GeneralTermsPageSectionsConfig: Section[] = [
    {
      heading: 'general_part_heading',
      paragraphs: [
            {
                text: 'general_part_paragraph_1'
            },
            {
                text: 'general_part_paragraph_2'
            },
            {
                text: 'general_part_paragraph_3'
            },
            {
                text: 'general_part_paragraph_4'
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'definitions_heading',
        paragraphs: [
            {
                text: 'definitions_paragraph_1'
            },
            {
                text: 'definitions_paragraph_2'
            },
            {
                text: 'definitions_paragraph_3'
            },
            {
                text: 'definitions_paragraph_4'
            },
            {
                text: 'definitions_paragraph_5'
            },
            {
                text: 'definitions_paragraph_6'
            },
            {
                text: 'definitions_paragraph_7'
            },
            {
                text: 'definitions_paragraph_8'
            },
            {
                text: 'definitions_paragraph_9'
            },
            {
                text: 'definitions_paragraph_10'
            },
            {
                text: 'definitions_paragraph_11'
            },
            {
                text: 'definitions_paragraph_12'
            },
            {
                text: 'definitions_paragraph_13'
            },
            {
                text: 'definitions_paragraph_14'
            },
            {
                text: 'definitions_paragraph_15'
            },
            {
                text: 'definitions_paragraph_16'
            },
            {
                text: 'definitions_paragraph_17'
            },
            {
                text: 'definitions_paragraph_18',
                letterList: [
                    {
                        text: 'definitions_paragraph_18_letter_1',
                        romanSubList: [
                            {
                                text: 'definitions_paragraph_18_letter_1_roman_1'
                            },
                            {
                                text: 'definitions_paragraph_18_letter_1_roman_2'
                            }
                        ]
                    },
                    {
                        text: 'definitions_paragraph_18_letter_2',
                    },
                    {
                        text: 'definitions_paragraph_18_letter_3',
                    },
                    {
                        text: 'definitions_paragraph_18_letter_4',
                    },
                    {
                        text: 'definitions_paragraph_18_letter_5',
                    }
                ]
            },
            {
                text: 'definitions_paragraph_19'
            },
            {
                text: 'definitions_paragraph_20'
            },
            {
                text: 'definitions_paragraph_21'
            },
            {
                text: 'definitions_paragraph_22'
            },
            {
                text: 'definitions_paragraph_23'
            },
            {
                text: 'definitions_paragraph_24'
            },
            {
                text: 'definitions_paragraph_25'
            },
            {
                text: 'definitions_paragraph_26'
            },
            {
                text: 'definitions_paragraph_27'
            },
            {
                text: 'definitions_paragraph_28'
            },
            {
                text: 'definitions_paragraph_29'
            },
            {
                text: 'definitions_paragraph_30'
            },
            {
                text: 'definitions_paragraph_31'
            },
            {
                text: 'definitions_paragraph_32'
            },
            {
                text: 'definitions_paragraph_33'
            },
            {
                text: 'definitions_paragraph_34'
            },
            {
                text: 'definitions_paragraph_35'
            },
            {
                text: 'definitions_paragraph_36'
            },
            {
                text: 'definitions_paragraph_37'
            },
            {
                text: 'definitions_paragraph_38'
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'subject_of_agreement_heading',
        paragraphs: [
            {
                text: 'subject_of_agreement_paragraph_1'
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'authorization_heading',
        paragraphs: [
            {
                text: 'authorization_paragraph_1'
            },
            {
                text: 'authorization_paragraph_2'
            },
            {
                text: 'authorization_paragraph_3'
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'content_of_service_heading',
        paragraphs: [
            {
                text: 'content_of_service_paragraph_1',
                list: [
                    {
                        text: 'content_of_service_paragraph_1_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'content_of_service_paragraph_1_list_2',
                        newOrderSubList: [
                            {
                                text: 'content_of_service_paragraph_1_list_2_sublist_1',
                            },
                            {
                                text: 'content_of_service_paragraph_1_list_2_sublist_2',
                            },
                            {
                                text: 'content_of_service_paragraph_1_list_2_sublist_3',
                            },
                            {
                                text: 'content_of_service_paragraph_1_list_2_sublist_4',
                            },
                            {
                                text: 'content_of_service_paragraph_1_list_2_sublist_5',
                            }
                        ],
                        languageToShow: [Language.LT, Language.EN]
                    },
                ],
            },
            {
                text: 'content_of_service_paragraph_2',
                list: [
                    {
                        text: 'content_of_service_paragraph_2_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'content_of_service_paragraph_2_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'content_of_service_paragraph_2_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'content_of_service_paragraph_2_list_4',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'content_of_service_paragraph_2_list_5',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'content_of_service_paragraph_2_list_6',
                        languageToShow: [Language.LT, Language.EN]
                    },
                ]
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: "rights_and_obligations_heading",
        paragraphs: [
            {
                text: 'rights_and_obligations_paragraph_1',
                list: [
                    {
                        text: 'rights_and_obligations_paragraph_1_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_1_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_1_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_1_list_4',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ],
            },
            {
                text: 'rights_and_obligations_paragraph_2',
                list: [
                    {
                        text: 'rights_and_obligations_paragraph_2_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_2_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_2_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_2_list_4',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_2_list_5',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_2_list_6',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_2_list_7',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ]
            },
            {
                text: 'rights_and_obligations_paragraph_3',
                list: [
                    {
                        text: 'rights_and_obligations_paragraph_3_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_4',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_5',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_6',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_7',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_8',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_9',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_10',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_11',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_12',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_13',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_14',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_15',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_16',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_17',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_18',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_19',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_20',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_21',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_22',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_3_list_23',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ]
            },
            {
                text: 'rights_and_obligations_paragraph_4',
                list: [
                    {
                        text: 'rights_and_obligations_paragraph_4_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_4',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_5',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_6',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_7',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_8',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_9',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_10',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_11',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_12',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_13',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_14',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_15',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_16',
                        subList: [
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_1',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_2',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_3',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_4',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_5',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_6',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_7',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_8',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_9',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_10',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_11',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_12',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_13',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_14',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_15',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_16',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_17',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_18',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_19',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_20',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_21',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_22',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_16_sublist_23',
                            }
                        ],
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_17',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_18',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_19',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_20',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_21',
                        subList: [
                            {
                                text: 'rights_and_obligations_paragraph_4_list_21_sublist_1',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_21_sublist_2',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_21_sublist_3',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_21_sublist_4',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_21_sublist_5',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_21_sublist_6',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_21_sublist_7',
                            }
                        ],
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_4_list_22',
                        subList: [
                            {
                                text: 'rights_and_obligations_paragraph_4_list_22_sublist_1',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_22_sublist_2',
                            },
                            {
                                text: 'rights_and_obligations_paragraph_4_list_22_sublist_3',
                            }
                        ],
                        languageToShow: [Language.LT, Language.EN]
                    }
                ]
            },
            {
                text: 'rights_and_obligations_paragraph_5',
                list: [
                    {
                        text: 'rights_and_obligations_paragraph_5_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_5_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ]
            },
            {
                text: 'rights_and_obligations_paragraph_6',
                list: [
                    {
                        text: 'rights_and_obligations_paragraph_6_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_6_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'rights_and_obligations_paragraph_6_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ]
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'self_service_heading',
        paragraphs: [
            {
                text: 'self_service_paragraph_1'
            },
            {
                text: 'self_service_paragraph_2'
            },
            {
                text: 'self_service_paragraph_3'
            },
            {
                text: 'self_service_paragraph_4'
            },
            {
                text: 'self_service_paragraph_5'
            },
          ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'digital_signature_heading',
        paragraphs:[
            {
                text: 'digital_signature_paragraph_1'
            },
            {
                text: 'digital_signature_paragraph_2',
                list: [
                    {
                        text: 'digital_signature_paragraph_2_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'digital_signature_paragraph_2_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ]
            },
            {
                text: 'digital_signature_paragraph_3'
            },
            {
                text: 'digital_signature_paragraph_4'
            },
            {
                text: 'digital_signature_paragraph_5'
            },
            {
                text: 'digital_signature_paragraph_6'
            },
            {
                text: 'digital_signature_paragraph_7'
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'taxes_heading',
        paragraphs:[
            {
                text: 'taxes_paragraph_1'
            },
            {
                text: 'taxes_paragraph_2'
            },
            {
                text: 'taxes_paragraph_3'
            },
            {
                text: 'taxes_paragraph_4'
            },
            {
                text: 'taxes_paragraph_5'
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'deposit_heading',
        paragraphs:[
            {
                text: 'deposit_paragraph_1',
                list: [
                    {
                        text: 'deposit_paragraph_1_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'deposit_paragraph_1_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ]
            },
            {
                text: 'deposit_paragraph_2'
            },
            {
                text: 'deposit_paragraph_3',
                list: [
                    {
                        text: 'deposit_paragraph_3_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'deposit_paragraph_3_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'deposit_paragraph_3_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'deposit_paragraph_3_list_4',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ]
            },
            {
                text: 'deposit_paragraph_4'
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'errors_heading',
        paragraphs: [
            {
                text: 'errors_paragraph_1'
            },
            {
                text: 'errors_paragraph_2'
            },
            {
                text: 'errors_paragraph_3'
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'operation_cancellation_heading',
        paragraphs: [
            {
                text: 'operation_cancellation_paragraph_1'
            },
            {
                text: 'operation_cancellation_paragraph_2'
            },
            {
                text: 'operation_cancellation_paragraph_3'
            },
            {
                text: 'operation_cancellation_paragraph_4'
            },
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'disputes_heading',
        paragraphs: [
            {
                text: 'disputes_paragraph_1'
            },
            {
                text: 'disputes_paragraph_2'
            },
            {
                text: 'disputes_paragraph_3'
            },
            {
                text: 'disputes_paragraph_4'
            },
            {
                text: 'disputes_paragraph_5'
            },
            {
                text: 'disputes_paragraph_6'
            },
            {
                text: 'disputes_paragraph_7'
            },
            {
                text: 'disputes_paragraph_8'
            },
            {
                text: 'disputes_paragraph_9'
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'confidentiality_heading',
        paragraphs: [
            {
                text: 'confidentiality_paragraph_1'
            },
            {
                text: 'confidentiality_paragraph_2',
                list: [
                    {
                        text: 'confidentiality_paragraph_2_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'confidentiality_paragraph_2_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'confidentiality_paragraph_2_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ]
            },
            {
                text: 'confidentiality_paragraph_3'
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'personal_data_heading',
        paragraphs: [
            {
                text: 'personal_data_paragraph_1'
            },
            {
                text: 'personal_data_paragraph_2',
                list: [
                    {
                        text: 'personal_data_paragraph_2_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'personal_data_paragraph_2_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'personal_data_paragraph_2_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'personal_data_paragraph_2_list_4',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ]
            },
            {
                text: 'personal_data_paragraph_3',
                list: [
                    {
                        text: 'personal_data_paragraph_3_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'personal_data_paragraph_3_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'personal_data_paragraph_3_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'personal_data_paragraph_3_list_4',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'personal_data_paragraph_3_list_5',
                        subList: [
                            {
                                text: 'personal_data_paragraph_3_list_5_sublist_1',
                            },
                            {
                                text: 'personal_data_paragraph_3_list_5_sublist_2',
                            },
                            {
                                text: 'personal_data_paragraph_3_list_5_sublist_3',
                            }
                        ],
                        languageToShow: [Language.LT, Language.EN]
                    }
                ]
            },
            {
                text: 'personal_data_paragraph_4'
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'liability_heading',
        paragraphs: [
            {
                text: 'liability_paragraph_1'
            },
            {
                text: 'liability_paragraph_2'
            },
            {
                text: 'liability_paragraph_3'
            },
            {
                text: 'liability_paragraph_4'
            },
            {
                text: 'liability_paragraph_5'
            },
            {
                text: 'liability_paragraph_6'
            },
            {
                text: 'liability_paragraph_7',
                list: [
                    {
                        text: 'liability_paragraph_7_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'liability_paragraph_7_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'liability_paragraph_7_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'liability_paragraph_7_list_4',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'liability_paragraph_7_list_5',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'liability_paragraph_7_list_6',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'liability_paragraph_7_list_7',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'liability_paragraph_7_list_8',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'liability_paragraph_7_list_9',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'liability_paragraph_7_list_10',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ]
            },
            {
                text: 'liability_paragraph_8'
            },
            {
                text: 'liability_paragraph_9'
            },
            {
                text: 'liability_paragraph_10'
            },
            {
                text: 'liability_paragraph_11'
            },
            {
                text: 'liability_paragraph_12'
            },
            {
                text: 'liability_paragraph_13'
            },
            {
                text: 'liability_paragraph_14'
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'validity_of_agreement_heading',
        paragraphs: [
            {
                text: 'validity_of_agreement_paragraph_1'
            },
            {
                text: 'validity_of_agreement_paragraph_2'
            },
            {
                text: 'validity_of_agreement_paragraph_3'
            },
            {
                text: 'validity_of_agreement_paragraph_4'
            },
            {
                text: 'validity_of_agreement_paragraph_5'
            },
            {
                text: 'validity_of_agreement_paragraph_6'
            },
            {
                text: 'validity_of_agreement_paragraph_7',
                list: [
                    {
                        text: 'validity_of_agreement_paragraph_7_list_1',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'validity_of_agreement_paragraph_7_list_2',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'validity_of_agreement_paragraph_7_list_3',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'validity_of_agreement_paragraph_7_list_4',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'validity_of_agreement_paragraph_7_list_5',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'validity_of_agreement_paragraph_7_list_6',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'validity_of_agreement_paragraph_7_list_7',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'validity_of_agreement_paragraph_7_list_8',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'validity_of_agreement_paragraph_7_list_9',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'validity_of_agreement_paragraph_7_list_10',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'validity_of_agreement_paragraph_7_list_11',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'validity_of_agreement_paragraph_7_list_12',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'validity_of_agreement_paragraph_7_list_13',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'validity_of_agreement_paragraph_7_list_14',
                        languageToShow: [Language.LT, Language.EN]
                    },
                    {
                        text: 'validity_of_agreement_paragraph_7_list_15',
                        languageToShow: [Language.LT, Language.EN]
                    }
                ]
            },
            {
                text: 'validity_of_agreement_paragraph_8'
            },
            {
                text: 'validity_of_agreement_paragraph_9'
            },
            {
                text: 'validity_of_agreement_paragraph_10'
            },
            {
                text: 'validity_of_agreement_paragraph_11'
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'communication_heading',
        paragraphs: [
            {
                text: 'communication_paragraph_1'
            },
            {
                text: 'communication_paragraph_2'
            },
            {
                text: 'communication_paragraph_3'
            },
            {
                text: 'communication_paragraph_4'
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    },
    {
        heading: 'other_conditions_heading',
        paragraphs: [
            {
                text: 'other_conditions_paragraph_1'
            },
            {
                text: 'other_conditions_paragraph_2'
            },
            {
                text: 'other_conditions_paragraph_3'
            },
            {
                text: 'other_conditions_paragraph_4'
            },
            {
                text: 'other_conditions_paragraph_5'
            },
            {
                text: 'other_conditions_paragraph_6'
            }
        ],
        languageToShow: [Language.LT, Language.EN]
    }
]
